import React from 'react';

import { BrandLinks } from '../brands/Link';
import {
  currencyRangeColumn,
  dateColumn,
  withoutSum,
} from '../utils/column-helpers';
import { ownerLink as commonOwnerLink } from '../utils/columns';
import OpportunityLink from './OpportunityLink';
import StageBadge from './StageBadge';

const nameLink = {
  Header: 'Opportunities',
  accessor: 'name',
  width: 225,
  Cell: row => <OpportunityLink model={row.original} />,
};

const stage = {
  Header: 'Stage',
  accessor: 'stage',
  width: 130,
  Cell: row => <StageBadge stage={row.original.stage} />,
};

const brandLink = {
  Header: 'Brands',
  accessor: 'brands',
  width: 340,
  Cell: row => <BrandLinks models={row.value} />,
};

const budget = withoutSum(
  currencyRangeColumn({
    Header: 'Budget',
    accessor: 'agreementOpportunities[0].budget',
    id: 'budget',
    width: 220,
  }),
);

const start = dateColumn('Start', 'campaignStart', 95);
const end = dateColumn('End', 'campaignEnd', 95);

const ownerLink = {
  ...commonOwnerLink,
  width: 150,
};

export default [nameLink, stage, brandLink, budget, start, end, ownerLink];
